export enum TicketPermission {
  RoleView = 'TK_ROLE_VIEW',
  RoleWrite = 'TK_ROLE_WRITE',

  EventView = 'TK_EVENT_VIEW',
  EventWrite = 'TK_EVENT_WRITE',

  ModuleWrite = 'TK_MODULE_WRITE',

  UserInvite = 'TK_USER_INVITE',

  ReportPageView = 'TK_REPORT_PAGE_VIEW',

  LocationSettingsView = 'TK_LOCATION_SETTINGS_VIEW',
  LocationSettingsWrite = 'TK_LOCATION_SETTINGS_WRITE',

  BusinessSettingsView = 'TK_BUSINESS_SETTINGS_VIEW',
  BusinessSettingsWrite = 'TK_BUSINESS_SETTINGS_WRITE',

  PaymentAccountView = 'TK_PAYMENT_ACCOUNT_VIEW',
  PaymentAccountWrite = 'TK_PAYMENT_ACCOUNT_WRITE',

  TicketSettingsView = 'TK_TICKET_SETTINGS_VIEW',
  TicketSettingsWrite = 'TK_TICKET_SETTINGS_WRITE',

  LegalSettingsView = 'TK_LEGAL_SETTINGS_VIEW',
  LegalSettingsWrite = 'TK_LEGAL_SETTINGS_WRITE',

  ProductionsView = 'TK_PRODUCTIONS_VIEW',
  ProductionsWrite = 'TK_PRODUCTIONS_WRITE',

  OfflineTicketSelling = 'TK_OFFLINE_TICKET_SELLING',
  OfflineTicketView = 'TK_OFFLINE_TICKET_VIEW',
  OfflineTicketRefund = 'TK_OFFLINE_TICKET_REFUND',

  OnlineTicketSelling = 'TK_ONLINE_TICKET_SELLING',
  OnlineTicketView = 'TK_ONLINE_TICKET_VIEW',
  OnlineTicketRefund = 'TK_ONLINE_TICKET_REFUND',

  ProtocolTicketSelling = 'TK_PROTOCOL_TICKET_SELLING',
  ProtocolTicketView = 'TK_PROTOCOL_TICKET_VIEW',
  ProtocolTicketRefund = 'TK_PROTOCOL_TICKET_REFUND',

  PromoterTicketSelling = 'TK_PROMOTER_TICKET_SELLING',
  PromoterTicketView = 'TK_PROMOTER_TICKET_VIEW',
  PromoterTicketRefund = 'TK_PROMOTER_TICKET_REFUND',

  ProductSelling = 'TK_PRODUCT_SELLING',
  ProductView = 'TK_PRODUCT_VIEW',
  ProductWrite = 'TK_PRODUCT_WRITE',
  ProductRefund = 'TK_PRODUCT_REFUND',

  PassSelling = 'TK_PASS_SELLING',
  PassView = 'TK_PASS_VIEW',
  PassWrite = 'TK_PASS_WRITE',
  PassRefund = 'TK_PASS_REFUND',

  GiftCardSelling = 'TK_GIFT_CARD_SELLING',
  GiftCardView = 'TK_GIFT_CARD_VIEW',
  GiftCardWrite = 'TK_GIFT_CARD_WRITE',
  GiftCardRefund = 'TK_GIFT_CARD_REFUND',

  ReservationView = 'TK_RESERVATION_VIEW',
  ReservationWrite = 'TK_RESERVATION_WRITE',

  PromoterPageView = 'TK_PROMOTER_PAGE_VIEW',
  PromoterInvite = 'TK_PROMOTER_INVITE',

  OperationLogsView = 'TK_OPERATION_LOGS_VIEW',

  ScanningPageView = 'TK_SCANNING_PAGE_VIEW',

  Coupon = 'TK_COUPON',
  Newsletter = 'TK_NEWSLETTER',
  Donations = 'TK_DONATIONS',

  Developer = 'TK_DEVELOPER',
}
